<template>
  <div class="app" id="app" v-bind:class="{ 'font-big': fontSize == 'big', 'font-medium': fontSize == 'medium', 'is-fixed': isFiltersOpened && isMobile}">
    <router-view></router-view>

    <app-footer></app-footer>

    <cookies></cookies>

    <back-to-top text="Back to top" visibleOffset="200" v-bind:title="$lang.go_top"></back-to-top>
  </div>
</template>

<script>
import Footer from './components/Footer/Footer'
import Cookies from './components/Global/Cookies'
import { thousandNumberFormat } from './scripts/directives/thousandNumberFormatDirective'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  components: {
    'app-footer': Footer,
    'cookies': Cookies
  },
  directives: {
    thousandNumberFormat
  },
  methods: {
    handleScroll () {
      return this.$store.commit('SET_APP_SCROLL', window.scrollY > 400)
    },
    handleResize () {
      return this.$store.commit('SET_IS_MOBILE', window.innerWidth <= 767)
    }
  },
  created () {
    //set language from cookies
    if (this.$cookies.isKey('lang')) {
      this.$setLang(this.$cookies.get('lang'))
    }
    document.title = this.$lang.title
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapGetters({
      fontSize: 'GET_FONT_SIZE',
      isFiltersOpened: 'GET_IS_FILTER_BOX',
      isMobile: 'GET_IS_MOBILE'
    })
  }
}
</script>

<style lang="sass">
@import './assets/sass/main.sass'
</style>



// WEBPACK FOOTER //
// App.vue?6f89ddc9